import { Button } from "@itandi/itandi-bb-ui/Button";
import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import clsx from "clsx";
import React from "react";
import { useSummaryFileTemplates } from "~/hooks/useSummaryFileTemplates";
import type { SummaryFileTemplateType } from "~/models/SummaryFileTemplate";
import { isSuccess } from "~/utils/api/api_handler";
import { create } from "~/utils/api/SummaryFileTemplate";
import Styles from "./SummaryFileTemplateRow.module.scss";

type Props = {
	fileType: SummaryFileTemplateType;
};

export function SummaryFileTemplateRowNoSetting({ fileType }: Props) {
	const { notify } = useNotification();
	const { mutate } = useSummaryFileTemplates().useIndex();
	const inputFileRef = React.useRef<HTMLInputElement>(null);
	const handleChangeFile = React.useCallback(
		async (e: React.ChangeEvent<HTMLInputElement>) => {
			if (e.target.files === null || inputFileRef.current === null) {
				return;
			}
			const response = await create(e.target.files[0], fileType);
			inputFileRef.current.value = "";
			if (isSuccess(response)) {
				await mutate();
				notify({ content: "アップロードしました。", variant: "success" });
				return;
			}
			notify({
				content: `エラーが発生しました。${response.message}`,
				variant: "error"
			});
		},
		[fileType, mutate, notify]
	);
	const onClickUpload = React.useCallback(() => {
		inputFileRef?.current?.click();
	}, [inputFileRef]);
	return (
		<div className={Styles.SettingContents}>
			<span className={clsx(Styles.SettingLabel, Styles.NoSetting)}>
				未設定
			</span>
			<input
				accept=".xlsx"
				className={Styles.HideFilePostInput}
				onChange={handleChangeFile}
				ref={inputFileRef}
				type="file"
			/>
			<Button height="small" onClick={onClickUpload}>
				アップロード
			</Button>
		</div>
	);
}
